import styled, { css } from 'styled-components';
import { Absolute, Box } from '@rsos/components/capstone/base';
import { withLayout } from '@rsos/components/capstone/base/Layout';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { QUEUE_FIXED_WIDTH } from '@rsos/constants/queueWidths';
import { Container as QueueContainer } from '../Queue/Queue.styles';
import { SearchBarWrapper as UniversalSearchBarWrapper } from './UniversalSearch/ConnectedUniversalSearch.styles';

export const FullWidthBox = styled(Box).attrs({
  grow: true,
  align: 'center',
  bg: 'background',
})`
  z-index: 0;
  ${({ isViewingAlerts }) => !isViewingAlerts && `width: 100%`};
`;

export const EventDetailsContainer = styled(Box).attrs({
  grow: true,
  horizontal: true,
})`
  ${({ isViewingAlerts }) => !isViewingAlerts && `width: 100%`};
  ${({ isIRP, selectedItem, isAllCallsSelected }) =>
    !isIRP &&
    (selectedItem || isAllCallsSelected) &&
    css`
      @media (max-width: ${BP_LAPTOP}px) {
        flex-direction: column-reverse;
      }
    `}
  overflow-y:hidden;
`;

export const MainContainer = withLayout(styled(Box).attrs({
  horizontal: true,
})`
  ${({ isIRP }) =>
    !isIRP &&
    css`
      @media (max-width: ${BP_LAPTOP}px) {
        flex-direction: column;
      }
      height: 100%;
    `}
  z-index: 0;
`);

export const SearchAndQueueContainer = styled(Box).attrs()`
  ${({ isIRP }) =>
    !isIRP &&
    css`
      @media (max-width: ${BP_LAPTOP}px) {
        width: 100%;
      }
    `}
  transition: all 0.3s ease-in-out;
  height: 100%;

  gap: ${({ isCollapsed }) => (isCollapsed ? '8px' : '0')};
  align-items: ${({ isCollapsed }) => (isCollapsed ? 'center' : 'stretch')};
  width: ${({ isCollapsed }) =>
    isCollapsed ? '75px' : `${QUEUE_FIXED_WIDTH}px`};
  min-width: ${({ isCollapsed }) =>
    isCollapsed ? '75px' : `${QUEUE_FIXED_WIDTH}px`};

  ${UniversalSearchBarWrapper} {
    opacity: ${({ isCollapsed }) => (isCollapsed ? '0' : '1')};
    visibility: ${({ isCollapsed }) => (isCollapsed ? 'hidden' : 'visible')};
    flex: ${({ isCollapsed }) => (isCollapsed ? '0 0 0' : '0 0 auto')};
    width: ${({ isCollapsed }) => isCollapsed && '0'};
    padding: ${({ isCollapsed }) => isCollapsed && '0'};
    height: auto;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
  }

  ${QueueContainer} {
    opacity: ${({ isCollapsed }) => (isCollapsed ? '0' : '1')};
    visibility: ${({ isCollapsed }) => (isCollapsed ? 'hidden' : 'visible')};
    flex: ${({ isCollapsed }) => (isCollapsed ? '0 0 0' : '1 1 0')};
    width: ${({ isCollapsed }) => isCollapsed && '0'};
    padding: ${({ isCollapsed }) => isCollapsed && '0'};
    height: auto;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
  }
`;

export const TextTo911Container = styled(Absolute).attrs({
  width: '400px',
  top: 10,
  left: 10,
  zIndex: 3,
})`
  ${css`
    @media (max-width: ${BP_LAPTOP}px) {
      left: 0;
      right: 0;
      margin: auto;
    }
  `}
`;
